<template>
	<div class="model-picker">
		<h4
			v-for="prebuild in prebuilds"
			:key="prebuild.id"
			:class="{
				'model-picker__model--selected': prebuild.id === currentPrebuildId
			}"
			class="model-picker__model"
			@click="selectPrebuild(prebuild)"
		>
			<span class="model-picker__model__text">
				<small>{{ prebuild.name.small }}</small> {{ prebuild.name.rest }}

				<template v-if="PREBUILD_ICONS_BY_SLUG[prebuild.slug]">
					<span
						:class="PREBUILD_ICONS_BY_SLUG[prebuild.slug].class"
						v-html="PREBUILD_ICONS_BY_SLUG[prebuild.slug].icon"
					/>
				</template>
				<template v-if="showPrice">
					<span class="model-picker__price">
						<promo-sales-timed>
							<template v-slot:originalContent>
								${{ prebuild.base_price }}
							</template>
							<template> ${{ promoDiscount(prebuild.base_price) }} </template>
						</promo-sales-timed>
					</span>
				</template>
			</span>
		</h4>
	</div>
</template>

<script>
import { PREBUILD_ICONS_BY_SLUG } from "./constants";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { promoDiscount } from "@u/helpers";

export default {
	name: "PrebuildModelPicker",
	components: {
		PromoSalesTimed
	},
	props: {
		prebuildsList: {
			type: Array,
			default() {
				return [];
			}
		},
		currentPrebuildId: {
			type: [String, Object],
			default: ""
		},
		showPrice: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			// TODO: Modify this when the back-end sends the starter series icons
			PREBUILD_ICONS_BY_SLUG
		};
	},
	computed: {
		prebuilds() {
			return this.prebuildsList.map(prebuild => {
				const { small, rest } = this.getSeparatedName(prebuild.name);
				return {
					...prebuild,
					name: {
						small,
						rest
					}
				};
			});
		}
	},
	methods: {
		promoDiscount,
		getSeparatedName(name = "") {
			const regex = /[\w]+/g;
			const [small, ...rest] = name.match(regex);
			return {
				small,
				rest: rest.join(" ")
			};
		},
		selectPrebuild(prebuild) {
			const isAlreadySelected = this.currentPrebuildId === prebuild.id;

			if (!isAlreadySelected) {
				this.$emit("select", {
					id: prebuild.id,
					variants: prebuild.variants
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.model-picker {
	display: flex;
	cursor: pointer;

	&__model {
		margin: 0;
		flex: 1;
		text-align: center;
		font-size: 24px;
		color: #444259;
		font-weight: bold;
		letter-spacing: 0;
		padding-bottom: 10px;
		border-bottom: solid 4px transparent;
		transition: border-bottom 0.3s;
		position: relative;

		&:hover {
			border-bottom: solid 4px #e3e3e3;
		}

		&__text {
			text-align: left;
			display: flex;
			flex-direction: column;
			width: max-content;
			margin: 0 auto;
			position: relative;

			@media (min-width: 580px) and (max-width: 991px) {
				margin: 0;
				padding-left: 15px;
			}
		}

		small {
			color: rgba(68, 66, 89, 0.8);
			font-size: 14px;
			letter-spacing: 0;
			font-weight: bold;
		}

		.cross,
		.diamond {
			position: absolute;
			font-size: 18px;
		}

		.cross {
			color: #e45e39;
			top: 15px;
			right: -15px;
		}

		.diamond {
			color: #0076ff;
			right: -6px;
			top: 13px;
		}
	}

	&__model--selected,
	&__model--selected:hover {
		border-bottom: solid 4px #8d29a0;
	}

	&__price {
		color: #444259;
		font-size: 16px;
		letter-spacing: 0;
		font-weight: normal;
		display: block;
		margin: 10px 0 20px;
		margin: 7px 0 10px;
	}
}
</style>
